import React from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { TomosGrid } from './components/TomosGrid';
import { TomoIncludes } from './components/TomoIncludes';
import { BonusSection } from './components/BonusSection';
import { ProModules } from './components/ProModules';
import { Pricing } from './components/Pricing';
import { ComparisonTable } from './components/ComparisonTable';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white selection:bg-brand-200 selection:text-brand-900" data-id="element-0">
      <TopBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PainSection data-id="element-4" />
        <TomosGrid data-id="element-5" />
        <TomoIncludes data-id="element-6" />
        <BonusSection data-id="element-7" />
        <ProModules data-id="element-8" />
        <Pricing data-id="element-9" />
        <ComparisonTable data-id="element-10" />
        <Testimonials data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}